import React from "react";
import ButtonExcel from "../components/ButtonExcel";

const ButoonDescargarContainer = ({ HandleDescargar, disable }) => {
  return <ButtonExcel HandleChange={HandleDescargar} disable={disable} />;
};

export default ButoonDescargarContainer;
